import injectIntl from "../../../common/helpers/injectIntl";
import { connect } from "react-redux";
import withRouter from "../../utils/withRouter";

import { get, post } from "../../actions/general";
import { editUser } from "../../store/user/actions";
import { seo } from "../../../common/helpers/seo";

import lazyComponent from "./lazy";

const mapStateToProps = ({ user }) => ({ user });
const mapDispatchToProps = {
    get,
    post,
    editUser,
};

export default {
    component: withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(lazyComponent))),
    renderSeo: (store, allMessage, lang) => {
        return seo({ title: allMessage["menu.moderation"], allMessage, lang });
    },
};
